import { getSearchResult } from "components/Stacker/actions/SearchActions"
import Loader from "components/Stacker/components/Loader/Loader"
import { getRetailerProducts } from "components/Stacker/state/retailer/actions"
import {
  addAddedStack,
  setAddedStack,
  setPendingStack,
  updateProducts,
  stackerReset,
  clearProducts,
} from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import PropTypes from "prop-types"
import queryString from "query-string"
import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useContext,
} from "react"
import { useLocation } from "react-router"
import "./App.scss"
import { shallowEqual, useDispatch } from "react-redux"
import { StackerContext } from "components/DYStackers/StackerContext"
import { useSelector } from "react-redux"
import { wrapQueryArray } from "components/Stacker/utils/helpers/helpers"
import { useCallback } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { loadLocaleAsync } from "i18n/i18n-util.async"
import { useI18nContext } from "i18n/i18n-react"
import { locales } from "i18n/i18n-util"

function Chooser({ children }) {
  return <div className="col-12">{children}</div>
}

Chooser.propTypes = {
  children: PropTypes.any,
}

function Stacker({ children, styles }) {
  const className = `stacker-container d-flex col-xl-7 col-lg-7 ${styles ?? ""}`
  return (
    <div id="stacker-children" className={className}>
      {children}
    </div>
  )
}

Stacker.propTypes = {
  children: PropTypes.any,
  styles: PropTypes.string,
}

function ProductList({ children, styles }) {
  const className = `product_list-container col-xl-5 col-lg-5 ${styles ?? ""}`
  return (
    <div id="product-list" className={className}>
      {children}
    </div>
  )
}

ProductList.propTypes = {
  children: PropTypes.any,
  styles: PropTypes.string,
}

function App({ appType, children, searchParams }) {
  const canUpdateProducts = useRef(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const { locale, setLocale } = useI18nContext()
  const stackerContext = useContext(StackerContext)
  //const [searchQuery, setSearchQuery] = useState(searchParams)
  const isAppLoaded = useSelector((state) => state.stacker.isAppLoaded)
  const retailerLoaded = useSelector((state) => state.retailer.retailerLoaded)
  const sortParams = useSelector((state) => state.search.queryParams?.sort)
  const filterParams = useSelector(
    (state) => state.search?.filters?.filterString,
    shallowEqual
  )
  const params = useParams()
  const lastApplied = useSelector((state) => state.search.lastApplied)
  const navigate = useNavigate()
  // const currentPage = useSelector(
  //   (state) => state.stacker.pagination.currentPage
  // )
  //const isDataLoading = useSelector((state) => state.search.meta.isDataLoading)
  // const isPreviewing = useSelector((state) => state.stacker.isPreviewing)
  const isReviewing = useSelector((state) => state.stacker.isReviewing)
  const isRearrange = useSelector((state) => state.stacker.isRearrange)
  const searchProducts = useSelector(
    (state) => state.search.data.products,
    shallowEqual
  )
  const isNoResultView = useSelector(
    (state) => state.search.meta.isNoResultView
  )
  const pending = useSelector(
    (state) => state.stacker.pendingStack,
    shallowEqual
  )
  const added = useSelector((state) => state.stacker.addedStack, shallowEqual)

  const queryObj = queryString.parse(location.search, { decode: true })
  const [queryProducts, setQueryProducts] = useState(
    wrapQueryArray(queryObj.products)
  )

  const [showLoader, setShowLoader] = useState(!isAppLoaded || !retailerLoaded)

  const currentSearchParams = useRef(null)

  // const addQueryToPending = useCallback(
  //   (id) => {
  //     dispatch(addAddedStack(id))
  //   },
  //   [dispatch]
  // )

  const addPendingToAdded = useCallback(() => {
    if (!pending || !pending.length) return

    const stack = pending
    const id = stack.shift()
    dispatch(addAddedStack(id))
  }, [dispatch, pending])

  const updateAddedStack = useCallback(
    (stack) => {
      dispatch(setAddedStack(stack))
    },
    [dispatch]
  )

  const updatePendingStack = useCallback(
    (stack) => {
      dispatch(setPendingStack(stack))
    },
    [dispatch]
  )

  const doSearch = () => {
    if (!searchParams.fq === null) return
    if (!shallowEqual(currentSearchParams.current, searchParams)) {
      canUpdateProducts.current = true
      if (
        currentSearchParams.current?.fq !== searchParams.fq ||
        currentSearchParams.current?.sort !== searchParams.sort
      ) {
        dispatch(clearProducts())
      }
      currentSearchParams.current = searchParams
      dispatch(
        getSearchResult(
          searchParams,
          {
            isGiftGuideNavigation: false,
            isSearchPage: false,
            //isInfiniteScroll: true,
          },
          stackerContext.retailerId
        )
      )
    }
  }

  useEffect(() => {
    setShowLoader(!isAppLoaded || !retailerLoaded)
  }, [isAppLoaded, retailerLoaded])

  useEffect(() => {
    getRetailerProducts(stackerContext.retailerId, dispatch)
  }, [dispatch, stackerContext.retailerId])

  useEffect(() => {
    const q = queryString.parse(location.search, { decode: true })
    if (q.products) {
      setQueryProducts(wrapQueryArray(q.products))
    }
    const setLanguage = async (lang) => {
      if (lang !== locale) {
        if (locales.indexOf(lang) >= 0) {
          await loadLocaleAsync(lang)
          setLocale(lang)
          stackerContext.lang = lang
        }
      }
    }
    setLanguage(params.locale ?? q.lang ?? "en")
  }, [location])

  function setNewLocation() {
    const newQuery = queryString.parse(location.search, { decode: true })
    const currentQueryParamsString = queryString.stringify(newQuery, {
      encode: true,
    })

    newQuery.fq = filterParams
    newQuery.sort = sortParams
    const queryParamsString = queryString.stringify(newQuery, {
      encode: true,
    })
    if (currentQueryParamsString !== queryParamsString) {
      navigate(`${location.pathname}?${queryParamsString}`)
    }
  }

  useEffect(() => {
    setNewLocation()
  }, [lastApplied])

  // useEffect(() => {
  //   if (filterParams.length > 0 || queryObj.fq) {
  //     dispatch(updateProducts([]))
  //     //doSearch()
  //     setNewLocation()
  //   }
  // }, [dispatch, filterParams])

  // useEffect(() => {
  //   if (sortParams) {
  //     dispatch(updateProducts([]))
  //     //doSearch()
  //     setNewLocation()
  //   }
  // }, [dispatch, sortParams])

  useEffect(() => {
    if (searchParams) {
      doSearch()
    }
  }, [searchParams])

  useEffect(() => {
    return () => {
      dispatch(stackerReset())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useLayoutEffect(() => {
    if (searchProducts.length > 0 && canUpdateProducts) {
      canUpdateProducts.current = false
      let allProducts = []
      if (appType === "amulets") {
        searchProducts.forEach((product) => {
          product.variants.forEach((variant) => {
            allProducts = [
              ...allProducts,
              {
                baseProduct: product.baseProduct,
                url: product.url,
                ...variant,
              },
            ]
          })
        })
      } else {
        allProducts = searchProducts
      }
      dispatch(updateProducts(allProducts))
    }
  }, [searchProducts, appType, dispatch])

  useEffect(() => {
    // if (previousPage && currentPage > previousPage) {
    // 	doSearch();
    // }

    //const { added, pending } = stacks

    //if (searchParams) prepSearch();

    // if (isDataLoading && !canUpdateProducts) {
    //   setCanUpdateProducts(true)
    // }

    // if (searchProducts.length && canUpdateProducts) {
    // 	setCanUpdateProducts(false)
    // 	let allProducts = [];
    // 	if (appType === 'amulets') {
    // 		searchProducts.forEach(product => {
    // 			product.variants.forEach(variant => {
    // 				allProducts = [
    // 					...allProducts,
    // 					{ baseProduct: product.baseProduct, url: product.url, ...variant }
    // 				];
    // 			});
    // 		});
    // 	} else {
    // 		allProducts = searchProducts;
    // 	}
    // 	dispatch(updateProducts(allProducts));
    // }

    // Rearrange
    // if (
    // 	queryProducts.length === prevqueryProducts.length &&
    // 	!queryProducts.every((value, index) => value === prevqueryProducts[index])
    // ) {
    //	updateAddedStack(queryProducts);
    // }

    if (pending && pending.length > 0) {
      // Add pending amulet to added stack
      addPendingToAdded()
      return
    }

    if (queryProducts && added && queryProducts.length > added.length) {
      // URL updated add product to pending
      const newqueryProducts = queryProducts.filter((x) => !added.includes(x))
      updatePendingStack(newqueryProducts)
    } else if (
      queryProducts &&
      added &&
      queryProducts.length > 0 &&
      queryProducts.length < added.length
    ) {
      // Pending removed from stack
      const remainingqueryProducts = added.filter((x) =>
        queryProducts.includes(x)
      )
      updateAddedStack(remainingqueryProducts)
    } else if (
      queryProducts &&
      (queryProducts.length === 0 || queryProducts[0] === "") &&
      added &&
      added.length === 1
    ) {
      // All amulets removed
      updateAddedStack([])
    }
  }, [
    queryProducts,
    pending,
    added,
    addPendingToAdded,
    updatePendingStack,
    updateAddedStack,
  ])

  const containerClass = classNames(
    "stacker-app",
    "container-fluid",
    "position-relative",
    "h-100",
    appType,
    {
      fadein: isAppLoaded || isNoResultView,
    },
    {
      "opacity-0": !isAppLoaded && !isNoResultView,
    },
    {
      rearrange: isRearrange,
    },
    // {
    //   preview: isPreviewing,
    // },
    {
      review: isReviewing,
    }
  )

  // The reason visibility is used below to toggle everything as of this comment,
  // is because the React children need to run in order to populate everything.
  return (
    <React.Fragment>
      {showLoader && <Loader />}
      <div
        className={containerClass}
        style={{ visibility: showLoader ? "hidden" : undefined }}
      >
        <div className="row h-100 flex-column flex-xl-row">{children}</div>
      </div>
    </React.Fragment>
  )
}

App.propTypes = {
  appType: PropTypes.string,
  searchParams: PropTypes.object,
  children: PropTypes.any,
}

App.Chooser = Chooser
App.Stacker = Stacker
App.ProductList = ProductList
export default App
